import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: { id: "UA-141672389-3yar" }
});

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
